import React, { CSSProperties, PropsWithChildren } from "react";
import cn from "classnames";

type Props = {
  className?: string;
  verticalAlignClassName?: string;
  heightClassName?: string;
  style?: CSSProperties;
};
export const CardHeader: React.FC<PropsWithChildren<Props>> = ({
  children,
  style,
  className,
  verticalAlignClassName = "items-center",
  heightClassName = "h-20",
}) => {
  return (
    <div
      className={cn(
        "px-8 py-4 border-b rounded-t-xl bg-gray-50  flex flex-row justify-between",
        verticalAlignClassName,
        heightClassName,
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
};
